import $ from 'jquery';

$('.js-rooms').each((index, element) => {
  const $container = $(element);
  const $filters = $('.js-filter');
  const $filtersHeading = $('.js-filters-heading');
  const $filtersToggle = $('.js-filters-toggle');
  const $filtersReset = $('.js-filters-reset');
  const $filtersCount = $('.js-filters-count');
  const $rooms = $container.find('.js-room');

  function getKitchenValues() {
    return $filters
      .filter(`[name="kitchen"]:checked`)
      .map((index, element) => element.value)
      .toArray();
  }

  function getBedroomsValues() {
    return $filters
      .filter(`[name="bedrooms"]:checked`)
      .map((index, element) => element.value)
      .toArray();
  }

  function getCapacityValues() {
    return $filters
      .filter(`[name="capacity"]:checked`)
      .map((index, element) => element.value)
      .toArray();
  }

  function filterByKitchen(index, element) {
    const values = getKitchenValues();
    if (values.length <= 0) {
      return true;
    }
    const value = $(element).attr('data-kitchen');
    return values.includes(value);
  }

  function filterByBedrooms(index, element) {
    const values = getBedroomsValues();
    if (values.length <= 0) {
      return true;
    }
    const value = $(element).attr('data-bedrooms');
    return values.includes(value);
  }

  function filterByCapacity(index, element) {
    const values = getCapacityValues();
    if (values.length <= 0) {
      return true;
    }
    const value = $(element).attr('data-capacity');
    return values.includes(value);
  }

  function isFilterActive() {
    return $filters.filter(':checked').length > 0;
  }

  function filter() {
    const $filtersedRooms = $rooms
      .hide()
      .filter(filterByKitchen)
      .filter(filterByBedrooms)
      .filter(filterByCapacity)
      .show();
    $filtersReset.attr('disabled', !isFilterActive());
    $filtersCount.text($filtersedRooms.length);

    $filtersHeading.text(
      isFilterActive()
        ? 'Currently showing filtered room types'
        : 'Currently showing all room types'
    );

    $filtersToggle.text(
      isFilterActive() ? 'Change or Clear Filters' : 'Filter Rooms'
    );

    $filters.each(function (index, element) {
      const $element = $(element);
      const name = $element.attr('name');
      const value = $element.attr('value');
      const $rooms = $filtersedRooms.filter(
        `.js-room[data-${name}="${value}"]`
      );
      const $filterss = $filters.filter(`[name="${name}"]:checked`);
      $element.attr('disabled', $rooms.length <= 0 && $filterss.length <= 0);
    });
  }

  function reset() {
    $filters.map((index, filter) => $(filter).prop('checked', false));
    filter();
  }

  $filtersReset.on('click', reset);
  $filters.on('change', filter);
});
